document.addEventListener('DOMContentLoaded', function() {
    initializeReviewsCarousels();
    initializeReadMoreLinks();

    function initializeReviewsCarousels() {
        const carousels = document.querySelectorAll('.manitoba-stores-reviews-carousel .swiper');
        
        carousels.forEach(function(carousel) {
            const slides = carousel.querySelectorAll('.swiper-slide');
            
            if (slides.length < 2) {
                return;
            }
            
            const autoplayDelay = carousel.parentElement.dataset.autoplayDelay || 5000;
            
            const swiperConfig = {
                slidesPerView: 3,
                spaceBetween: 20,
                grabCursor: true,
                autoHeight: false,
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: true
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                }
            };

            // Récupérer l'ID du conteneur parent
            const carouselContainer = carousel.closest('.manitoba-stores-reviews-carousel');
            const carouselId = carouselContainer ? carouselContainer.id : null;
            
            // Ajouter la pagination si l'élément existe
            const paginationEl = carousel.querySelector('.swiper-pagination');
            if (paginationEl) {
                swiperConfig.pagination = {
                    el: paginationEl,
                    clickable: true,
                };
            }
            
            // Sélectionner les boutons de navigation avec l'ID du conteneur
            const nextEl = carouselId ? document.querySelector(`[data-nav-next="${carouselId}"]`) : null;
            const prevEl = carouselId ? document.querySelector(`[data-nav-prev="${carouselId}"]`) : null;
            if (nextEl && prevEl) {
                swiperConfig.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                };
            }

            new Swiper(carousel, swiperConfig);
        });
    }
    
    function initializeReadMoreLinks() {
        const readMoreLinks = document.querySelectorAll('.store-review-content .read-more-link');
        
        readMoreLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const reviewContent = this.closest('.store-review-content');
                const trimmedContent = reviewContent.querySelector('.trimmed-content');
                const fullContent = reviewContent.querySelector('.full-content');
                const readLessLink = reviewContent.querySelector('.read-less-link');
                
                if (fullContent) {
                    // Si le texte est actuellement tronqué (bouton "voir plus" visible)
                    if (this.classList.contains('read-more-link')) {
                        // Afficher le contenu complet
                        trimmedContent.style.display = 'none';
                        fullContent.style.display = 'block';
                        this.style.display = 'none'; // Cacher le lien "voir plus"
                        
                        // Afficher le lien "voir moins"
                        if (readLessLink) {
                            readLessLink.style.display = 'inline-block';
                        }
                    } 
                    // Si le texte est actuellement déplié (bouton "voir moins" visible)
                    else if (this.classList.contains('read-less-link')) {
                        // Afficher le contenu tronqué
                        trimmedContent.style.display = 'block';
                        fullContent.style.display = 'none';
                        this.style.display = 'none'; // Cacher le lien "voir moins"
                        
                        // Afficher le lien "voir plus"
                        const readMoreLink = reviewContent.querySelector('.read-more-link');
                        if (readMoreLink) {
                            readMoreLink.style.display = 'inline-block';
                        }
                    }
                }
            });
        });
        
        // Initialiser également les liens "voir moins"
        const readLessLinks = document.querySelectorAll('.store-review-content .read-less-link');
        readLessLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const reviewContent = this.closest('.store-review-content');
                const trimmedContent = reviewContent.querySelector('.trimmed-content');
                const fullContent = reviewContent.querySelector('.full-content');
                
                if (fullContent) {
                    // Afficher le contenu tronqué
                    trimmedContent.style.display = 'block';
                    fullContent.style.display = 'none';
                    this.style.display = 'none'; // Cacher le lien "voir moins"
                    
                    // Afficher le lien "voir plus"
                    const readMoreLink = reviewContent.querySelector('.read-more-link');
                    if (readMoreLink) {
                        readMoreLink.style.display = 'inline-block';
                    }
                }
            });
        });
    }
});